export const CREATE_CHANNEL_RULE_NOTIFICATION = {
  SUCCESS: 'Channel rule(s) created successfully',
  ERROR: 'Something went wrong whilst creating a channel rule',
};

export const UPDATE_CHANNEL_RULE_NOTIFICATION = {
  SUCCESS: 'Channel rule(s) updated successfully',
  ERROR: 'Something went wrong whilst updating a channel rule',
};
